import { createContext } from 'react';

const deleteConfirmDialogContext: any = createContext('');

export default deleteConfirmDialogContext;